import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators, UntypedFormArray, AbstractControl } from '@angular/forms';
import { SelectItem, MenuItem, ConfirmationService } from 'primeng/api';
import { Pays } from 'src/app/shared/models/iContact/global/pays';
import { Rue } from 'src/app/shared/models/iContact/global/rue';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import * as _ from 'underscore';
import { ToastrService } from 'ngx-toastr';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { UserInfo } from 'src/app/shared/models/iCourrier/me/user-info';
import { NgxSpinnerService } from 'ngx-spinner';
import { PostContact } from 'src/app/shared/models/iContact/post/post-contact';
import * as async from 'async';
import { ValidatorsComponent } from 'src/app/validators/validators.component';
import { Dropdown } from 'primeng/dropdown';
import * as countries from 'src/assets/country/phone.json';
import { HttpErrorResponse } from '@angular/common/http';
import { DataService } from 'src/app/shared/services/data.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import {
  GroupsGlobalDto,
  ContactTypeDto,
  DropdownContactTitleDTO,
  DropdownContactTypeDTO,
  DropdownLanguage,
  DropdownLegalForm,
  LowInformationsDTO,
  ManagementPostalCodesDTO,
  StreetByCountryIAddressDTO,
} from 'src/app/shared/interfaces';
import { LanguagesService } from 'src/app/shared/services/languages.service';
import { LegalFormsService } from 'src/app/shared/services/legal-forms.service';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { AddressesService } from 'src/app/shared/services/addresses.service';
import { CountriesService } from 'src/app/shared/services/countries.service';
import { CountryDto } from 'src/app/shared/interfaces/countries';
import { BusinessFieldsService } from 'src/app/shared/services/business-fields.service';
import { MaritalStatutesService } from 'src/app/shared/services/marital-statutes.service';
import { GendersService } from 'src/app/shared/services/genders.service';
import { NationalitiesService } from 'src/app/shared/services/nationalities.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ContactsGlobalService } from 'src/app/shared/services/contacts-global.service';
import { MeService } from 'src/app/shared/services/me.service';
import { PostalCodeByCountry } from 'src/app/shared/models/iContact/global/postal-code-by-country';
import { StreetsByCountry } from 'src/app/shared/models/iContact/global/streets-by-country';
import { PostalCodeByCountryDTO } from 'src/app/shared/interfaces/contacts/dtos/postal-code-by-country-dto.interface';
import { ConfigDto } from 'src/app/shared/interfaces/config';
import { PostalCodesStreetsParams } from 'src/app/shared/interfaces/contacts/params/postal-codes-streets-params.interface';
import { PostalCodesStreetsDTO } from 'src/app/shared/interfaces/contacts/dtos/postal-codes-streets-dto.interface';
import { AssetsCalendarFr } from 'src/app/shared/models/calendar-fr';
import { Router } from '@angular/router';
import { ManagementStreetsDTO } from 'src/app/shared/interfaces/addresses/dtos/streets-dto.interface';
import { GroupsService } from 'src/app/shared/services/groups.service';
import { ITabs } from '@devinforius/i-navigation';
import { AddressAsAList, AddressForFormArray } from 'src/app/shared/models/iContact/contact/adresse';
import { IButton } from '@devinforius/i-essentials';
import { catchError, forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-contact-new',
  templateUrl: './contact-new.component.html',
  styleUrls: ['./contact-new.component.scss'],
})
export class ContactNewComponent implements OnInit, AfterViewInit {
  public contact;
  public contacts: Contact[];

  public text: string;
  public caller: string;

  public contactForm: UntypedFormGroup;

  public titleButtons: IButton[] = [
    {
      text: 'Retour',
      styleClass: 'blue',
      click: () => {
        this.close();
      },
    },
    {
      text: 'Enregistrer',
      styleClass: 'green',
      click: () => {
        this.onSubmit();
        this.changeTabViewNotSaveDirectly = true;
      },
    },
  ];

  public countriesList: Pays[];
  public postalCodesList: PostalCodeByCountry[] = [];
  public filteredPostalCodes: PostalCodeByCountry[];
  public typeContacts: DropdownContactTypeDTO[] = [];
  public streetsList: Rue[];
  public filteredStreets: Rue[];
  public contactTitles: DropdownContactTitleDTO[] = [];
  public langues: DropdownLanguage[] = [];
  public companyMode = false; // default is false

  public contactId: number;
  public secteursList: { label: string; value: string }[] = [];
  public legalForms: DropdownLegalForm[] = [];
  public etatCivils: { label: string; value: string }[] = [];
  public sexes: { label: string; value: string }[] = [];
  public nationalites: { label: string; value: string }[] = [];

  public fullMode: boolean; // to see the whole form
  public locale4Calendar: AssetsCalendarFr; // locale for calendar
  public yearRange: string;
  public arrayItems: {
    id: number;
    structure_RueId: number;
    structure_RueNumero: number;
    structure_LocaliteId: number;
    pays: string;
  }[];
  public activeIndex = 0;
  public steps: MenuItem[] = [];
  public contactAdresses = [];
  public typesAdresses: { label: string; value: string }[] = [];

  public userInfos: UserInfo; // Access of the connected user
  public connectedUserID: number;
  public allcontacts: Array<Contact> = [];
  public codeTvaList: SelectItem[] = [
    { label: 'BE', value: 'BE' },
    { label: 'FR', value: 'FR' },
    { label: 'LU', value: 'LU' },
    { label: 'NL', value: 'NL' },
    { label: 'DE', value: 'DE' },
    { label: 'AUTRE', value: 'OTHER' },
  ];
  public tvaMask = `BE-9999999999`;
  public tvaRegex: '';
  public tvaPlaceholder = 'BE-9999999999';
  public tvaFrMode = false;
  public bcePlaceholder = '9999999999';
  public bceMask = '9999999999';
  public bceTooltip = '10 chiffres.';
  public tooltipMember = "Veuillez tout d'abord créer une contact afin de lier à un autre membre";
  public tooltipSociety = "Veuillez tout d'abord créer une contact afin de lier à une autre société";
  public isFormSubmit: boolean;
  public isDisabled: boolean;
  public btnTooltip = 'Enregistrer ce contact';
  public typeSocieteList = [
    { label: 'Personne physique', value: false },
    { label: 'Personne morale', value: true },
  ];
  public codePays = 'BE';

  public countryPhone = '+32';
  public prefixNumber = '';
  public countriesJSON = countries;
  public datebirthdefault = new Date();
  public hideSwitch: boolean; // for new contact link to hide typeSociete change
  @ViewChild('Dropdown') stateDropdown: Dropdown;
  @ViewChild('Dropdown2') stateDropdownFrench: Dropdown;
  @ViewChild('DropdownRue') stateDropdownRue: Dropdown;
  public saveOK = true;
  public paysContactID: number;
  public clientType = sessionStorage.getItem('clientType');

  public connectedContactAccessContacts: boolean;
  public showCreateCP = false;
  public showCreateStreet = false;
  public showCreateContactType = false;
  public formCP = new UntypedFormGroup({
    codePostal: new UntypedFormControl(null, Validators.required),
    localite: new UntypedFormControl(null),
    langueID: new UntypedFormControl(null),
    paysID: new UntypedFormControl(null),
  });
  public formStreet = new UntypedFormGroup({
    codePostal: new UntypedFormControl(null, Validators.required),
    codeRue: new UntypedFormControl(null),
    codeLangue: new UntypedFormControl('FR'),
    rue: new UntypedFormControl(null),
  });
  public formContactType = new UntypedFormGroup({
    typeContact: new UntypedFormControl(null, Validators.required),
    ordreTri: new UntypedFormControl(null),
    carnetContactID: new UntypedFormControl(null),
    nePasInclureArbreDestinataires: new UntypedFormControl(false),
    nePasRemplirLaListe: new UntypedFormControl(false),
    sanctionTypeVictime: new UntypedFormControl(null),
    categorie: new UntypedFormControl(false),
    categorieParent: new UntypedFormControl(0),
    verrouille: new UntypedFormControl(null),
    // creationGereeParGroupeID: new FormControl(null),
    // modificationGereeParGroupeId: new FormControl(null),
    // suppressionGereeParGroupeId: new FormControl(null),
    // visualisationGereeParGroupeID: new FormControl(null),
  });
  public countries = [];
  public typesLV = [];
  public groups = [];
  public contactsLinked = [];
  public contactsInit = [];
  public actualIndexOfAddressToBeModified: number;
  public typeOfAddressToBeModified: 'impression' | 'structure';
  public actualIndexOfStreetToBeModified: number;
  public typeOfStreetToBeModified: 'impression' | 'structure';

  public emailCheckPattern: number[] = [];
  emailPattern =
    /^[a-zA-Z0-9. !#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]{1}[.]{1}[a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]{1}$/;
  //Explanation of regex :
  //  [a-zA-Z0-9. !#$%&'*+\/=?^_`{|}~-]    => Accepts all character from 'a' to 'Z' (lowercase + uppercase)+ . + space character + accent letters + .!#$%&'*+\/=?^_`{|}~-
  // + => can have 1 or + or preceding

  // @  +> must have 1x @

  //  [a-zA-Z0-9]{1}  => must start by a to z or A to Z or from 0 to 9 => can only have 1 letter from the []
  // [a-zA-Z0-9-]{0,61}   => Must have same than above or '-' from 0 to 61 times
  // [a-zA-Z0-9]{1} => must have 1 character : a to z or A to Z or from 0 to 9
  // all this 3 together forces to have at least 2 characters with a max of 2+61.
  //so the 1st and last letters should be [a-zA-Z0-9] and in-between you can have 0 or 61 times [a-zA-Z0-9-]

  //[.]{1} must have 1 time a .

  //idem than the 3 together => must finish by min 2 letters [a-zA-Z0-9] and can have 0-61 times [a-zA-Z0-9-]

  emailPattern2 =
    /^[a-zA-Z0-9. !#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]{1}[.][a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]{1}[.]{1}[a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]{1}$/;
  //same than before but with 2 points ex xxxx@aaa.bbb.be

  public listOfDisplayedImpressionAdresses = [false];
  public filteredSectors: {
    label: string;
    value: string;
  }[] = [];
  public contactCreated: Contact = null;
  public changeTabViewNotSaveDirectly = false;

  public tabs: ITabs[] = [
    { header: 'Informations', id: 'info', active: true, icon: 'bi bi-info-circle me-2' },
    { header: 'Société(s) liée(s)', id: 'company', active: false, icon: 'bi bi-building me-2' },
  ];
  public selectedZIPByFrenchGouvApi = false;
  private timeoutForGouvCall = null;
  private numberPattern = /^[0-9]*$/;
  private config: ConfigDto;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private translationService: TranslationService,
    public confirmationService: ConfirmationService,
    private router: Router,
    private spinner: NgxSpinnerService,
    public dataService: DataService,
    public ref: DynamicDialogRef,
    public dataModal: DynamicDialogConfig,
    private langsService: LanguagesService,
    private legalFormsService: LegalFormsService,
    private contactsService: ContactsService,
    private addressesService: AddressesService,
    private countriesService: CountriesService,
    private businessFieldsService: BusinessFieldsService,
    private maritalStatutesService: MaritalStatutesService,
    private gendersService: GendersService,
    private nationalitiesService: NationalitiesService,
    private configService: ConfigService,
    private contactsGlobalService: ContactsGlobalService,
    private meService: MeService,
    private groupsService: GroupsService
  ) {}

  checkEmailPattern(index: number): boolean {
    this.emailCheckPattern = [];
    if (!this.getAdressPrincipal.at(index).value.mail) {
      return true;
    } else {
      if (
        this.emailPattern.test(this.getAdressPrincipal.at(index).value.mail) === false &&
        this.emailPattern2.test(this.getAdressPrincipal.at(index).value.mail) === false
      ) {
        this.emailCheckPattern.push(index);
        return false;
      } else {
        return true;
      }
    }
  }

  ngOnInit(): void {
    this.spinner.show();
    this.initForm();
    if (this.dataModal?.data) {
      this.caller = this.dataModal.data.caller ? this.dataModal.data.caller : null;
      this.companyMode = this.dataModal.data.companyMode ? this.dataModal.data.companyMode : false;
      this.hideSwitch = this.dataModal.data.hideSwitch ? this.dataModal.data.hideSwitch : null;
    }
    this.text = 'Nouveau contact';
    this.contact = new PostContact();
    this.getYearRange();

    forkJoin({
      calendarTranslation: this.translationService.getCalendartranslate(localStorage.getItem('lang')),
      config: this.configService.fetchConfig().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des paramètres globaux de configuration');
          return of(null);
        })
      ),
      meRightManagement: this.meService.rightManagement().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des droits personnels de gestion');
          return of(null);
        })
      ),
      addressTypes: this.contactsService.fetchAddressTypes().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error("Une erreur est survenue lors de la récupération des types d'adresses");
          return of(null);
        })
      ),
      countries: this.countriesService.fetchCountries().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des pays');
          return of(null);
        })
      ),
      typeContacts: this.contactsGlobalService.fetchMappedContactTypesToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des types de contacts');
          return of(null);
        })
      ),
      legalForms: this.legalFormsService.fetchMappedLegalFormsToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des formes juridiques');
          return of(null);
        })
      ),
      titles: this.contactsGlobalService.fetchMappedContactTitlesToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des titres');
          return of(null);
        })
      ),
      langages: this.langsService.fetchMappedLanguagesToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des langues');
          return of(null);
        })
      ),
      businessFields: this.businessFieldsService.fetchBusinessFields().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error("Une erreur est survenue lors de la récupération des secteurs d'activités");
          return of(null);
        })
      ),
      maritalStatus: this.maritalStatutesService.fetchMaritalStatutes().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des statuts matrimoniaux');
          return of(null);
        })
      ),
      genders: this.gendersService.fetchGenders().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des sexes');
          return of(null);
        })
      ),
      nationalities: this.nationalitiesService.fetchNationalities().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des nationalités');
          return of(null);
        })
      ),
    }).subscribe((value) => {
      this.locale4Calendar = value.calendarTranslation;
      this.connectedContactAccessContacts = value.meRightManagement.menu.contacts;
      this.formatAddressTypes(value.addressTypes);
      this.countriesList = value.countries;
      this.add();
      this.formatTypesContacts(value.typeContacts);
      this.legalForms = value.legalForms;
      this.contactTitles = value.titles;
      this.langues = value.langages;
      this.formatBusinessFields(value.businessFields);
      this.formatMaritalStatutes(value.maritalStatus);
      this.formatGenders(value.genders);
      this.formatNationalities(value.nationalities);
      this.contactForm.patchValue({
        mail: this.dataModal?.data?.emailUserFromMailFile ?? null,
      });
      this.spinner.hide();
    });
    this.contactForm?.valueChanges.subscribe({
      next: (val) => {
        if (val.typeSociete) {
          if (val.nom !== null && val.langueId !== null) {
            this.isDisabled = false;
            this.btnTooltip = 'Enregistrer ce contact';
          } else {
            this.isDisabled = true;
            this.btnTooltip = 'Il y a des erreurs dans le formulaire';
          }
        } else {
          if (val.nom !== null && val.langueId !== null && this.emailCheckPattern.length === 0) {
            this.isDisabled = false;
            this.btnTooltip = 'Enregistrer ce contact';
          } else {
            this.isDisabled = true;
            this.btnTooltip = 'Il y a des erreurs dans le formulaire';
          }
        }
      },
    });
  }

  private formatAddressTypes(addressTypes: string[]): void {
    addressTypes.map((item) => {
      this.typesAdresses.push({ label: item, value: item });
    });
  }

  private formatTypesContacts(typesContacts: DropdownContactTypeDTO[]): void {
    this.typeContacts = typesContacts;
    this.typeContacts.map((item) => {
      item.label = item.label.charAt(0).toUpperCase() + String(item.label).slice(1).toLowerCase();
    });
  }

  private formatBusinessFields(businessFields: string[]): void {
    businessFields.forEach((businessField) => {
      this.secteursList.push({ label: businessField, value: businessField });
    });
    this.secteursList = _.sortBy(this.secteursList, 'label');
  }

  private formatMaritalStatutes(maritalStatus: string[]): void {
    maritalStatus.forEach((maritalStatus) => {
      this.etatCivils.push({ label: maritalStatus, value: maritalStatus });
    });
    this.etatCivils = _.sortBy(this.etatCivils, 'label');
  }
  private formatGenders(genders: string[]): void {
    genders.forEach((gender) => {
      this.sexes.push({ label: gender, value: gender });
    });
    this.sexes = _.sortBy(this.sexes, 'label');
  }

  private formatNationalities(nationalities: string[]): void {
    nationalities.forEach((nationality) => {
      this.nationalites.push({ label: nationality, value: nationality });
    });
    this.nationalites = _.sortBy(this.nationalites, 'label');
  }

  ngAfterViewInit(): void {
    if (this.stateDropdown) {
      const random = 'nope-' + (Math.random() + 1).toString(36).substring(7);
      this.stateDropdown.renderer.setAttribute(this.stateDropdown.filterViewChild.nativeElement, 'autocomplete', random);
    }
  }

  private setAddressConfig(address: StreetsByCountry, boite: string, number: string): string {
    const params = this.config.groupContacts.impressionAddressOrder;
    let gen_address: string = null;
    const streetName = address.rueNom ? address.rueNom : '';

    if (address) {
      if (params === 'R') {
        gen_address = streetName;
      }
      if (params === 'RB') {
        gen_address = streetName + (boite ? ' bte ' + boite : '');
      }
      if (params === 'RN') {
        gen_address = streetName + ' ' + number;
      }
      if (params === 'BR') {
        gen_address = (boite ? ' bte ' + boite : '') + ' ' + streetName;
      }
      if (params === 'BN') {
        gen_address = (boite ? ' bte ' + boite : '') + ' ' + number;
      }
      if (params === 'NRB') {
        gen_address = number + ' ' + streetName + (boite ? ' bte ' + boite : '');
      }
      if (params === 'NBR') {
        gen_address = number + (boite ? ' bte ' + boite : '') + ' ' + streetName;
      }
      if (params === 'RNB') {
        gen_address = streetName + ' ' + number + (boite ? ' bte ' + boite : '');
      }
      if (params === 'RBN') {
        gen_address = streetName + (boite ? ' bte ' + boite : '') + ' ' + number;
      }
      if (params === 'BNR') {
        gen_address = (boite ? ' bte ' + boite : '') + ' ' + number + ' ' + streetName;
      }
      if (params === 'BRN') {
        gen_address = (boite ? ' bte ' + boite : '') + ' ' + streetName + ' ' + number;
      }
    } else {
      gen_address = '';
    }
    return gen_address;
  }

  public getYearRange(): void {
    this.yearRange = `${new Date().getFullYear() - 100}:${new Date().getFullYear()}`;
  }

  public onSubmit(): void {
    this.isFormSubmit = true;

    this.contact = new PostContact(this.contact);

    if (!this.paysContactID) {
      this.paysContactID = 1;
    }

    this.contact.listContactsAdresses = [];

    if (this.contactForm.value.titre) {
      this.contact.titre = this.contactForm.value.titre.titre;
    }

    this.checkIfStructuredAddressIsFilled().then(() => {
      this.checkIfStructureAndImpressionAddressesAreSame().then(() => {
        this.spinner.show();
        this.setAddressesAsAList().then((arrayOfAddresses) => {
          const temp_array_adress = arrayOfAddresses;
          this.contact = this.contactForm.value;

          if (this.f['tva'].value !== '' && this.f['tva'].value !== null) {
            this.contact['tva'] = this.f['tva'].value.replace(/-/g, '').replace(/\./g, '');
            this.contact['tva'] = this.contact['tva'].toUpperCase();
          }

          this.contact.paysContactID = this.paysContactID;

          if (this.paysContactID !== 1) {
            this.contact.pasDeTVABelge = true;
          } else this.contact.pasDeTVABelge = false;

          this.contact.listContactsAdresses = _.clone(temp_array_adress);

          this.contact.secteurActivite = this.contact.secteurActivite?.value;

          if (this.contact.typeSociete === null || this.contact.typeSociete === false) {
            this.submitNewPhysicalContact();
          } else {
            this.submitNewSocietyContact();
          }
        });
      });
    });
  }

  //to be Put in an utils
  private checkIfStructuredAddressIsFilled(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.contactForm.value.listContactsAdresses.length > 0) {
        const errors: string[] = [];
        async.eachSeries(
          this.contactForm.value.listContactsAdresses,
          (item: AddressForFormArray, cbEachSeries) => {
            if (item.toRemove) {
              //si l'adresse est a supprimer => aucune modif nécessaire
              cbEachSeries(null);
            } else if (item.impression_Adresse && item.structure_RueId === null) {
              this.spinner.hide();
              this.confirmationService.confirm({
                message:
                  "Pour l'adresse " +
                  item.type.toLowerCase() +
                  ', l’adresse impression est remplie mais l’adresse structurée est vide. Souhaitez-vous sauver tout de même?',
                key: 'confirmContact',
                accept: () => {
                  cbEachSeries(null);
                },
                reject: () => {
                  errors.push('refused');
                  cbEachSeries(null);
                },
              });
            } else {
              cbEachSeries(null);
            }
          },
          () => {
            //on va vérifier s'il y a une err car on ne peut pas break d'un async.each/ eachSeries
            errors?.length > 0 ? (this.saveOK = false) : (this.saveOK = true);
            resolve(true);
          }
        );
      } else {
        resolve(true);
      }
    });
  }

  //to be Put in an utils
  private checkIfStructureAndImpressionAddressesAreSame(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.contactForm.getRawValue().listContactsAdresses.length > 0) {
        const errors: string[] = [];
        async.eachSeries(
          this.contactForm.getRawValue().listContactsAdresses,
          (item: AddressForFormArray, cbAsyncEachSeries) => {
            if (item.toRemove) {
              //si l'adresse est a supprimer => aucune modif nécessaire
              cbAsyncEachSeries(null);
            } else if (
              (item.structure_LocaliteId && item.impression_CodePostal && item.structure_LocaliteId.codePostal !== item.impression_CodePostal) ||
              (item.structure_LocaliteId && item.impression_Localite && item.structure_LocaliteId.localite !== item.impression_Localite)
            ) {
              this.spinner.hide();
              this.confirmationService.confirm({
                message:
                  "Pour l'adresse " +
                  item.type.toLowerCase() +
                  ', l’adresse impression est différente de l’adresse structurée. Souhaitez-vous sauver tout de même?',
                key: 'confirmContact',
                accept: () => {
                  cbAsyncEachSeries(null);
                },
                reject: () => {
                  errors.push('refused');
                  cbAsyncEachSeries(null);
                },
              });
            } else {
              cbAsyncEachSeries(null);
            }
          },
          () => {
            //on va vérifier s'il y a une err car on ne peut pas break d'un async.each/ eachSeries
            errors?.length > 0 ? (this.saveOK = false) : (this.saveOK = true);
            resolve(true);
          }
        );
      } else {
        resolve(true);
      }
    });
  }

  //to be Put in an utils
  private setAddressesAsAList(): Promise<AddressAsAList[]> {
    return new Promise((resolve) => {
      const temp_array_adress: AddressAsAList[] = [];
      if (this.contactForm.getRawValue().listContactsAdresses.length > 0) {
        async.eachOfSeries(
          this.contactForm.getRawValue().listContactsAdresses,
          (item: AddressForFormArray, index, cbAsyncEachSeries) => {
            if (item.toRemove) {
              temp_array_adress.push(this.setNewAddress(item, index));
              cbAsyncEachSeries(null);
            } else {
              if (item.structure_LocaliteId?.id === -1 || !item.structure_LocaliteId?.id) {
                //! === -1 car l'utilisateur pourrait très bien garder le "voir plus" en l'ayant oublié => s'il a cliqué sur "voir plus" sans choisir de cp /  rue; que cela ne s'envoie pas au backend.
                item.structure_LocaliteId = null;
                item.structure_RueId = null;
              }
              if (item.structure_RueId?.id === -1 || !item.structure_RueId?.id) {
                item.structure_RueId = null;
              }

              // Si on a des adresses on va devoir vérifier si on a pas une localité ou une rue qui provient d'une autre api que celle de iAdmin.
              if (item.structure_LocaliteId?.isFromAnotherAPI || item.structure_RueId?.isFromAnotherAPI) {
                // Si on a au moins la rue ou la localite en isFromAnotherAPI alors on doit d'abord créer l'adresse dans iContact avant de pouvoir aller plus loin
                const zipAndStreetParams: PostalCodesStreetsParams = {
                  codePostal: {
                    codePostal: item.structure_LocaliteId.codePostal,
                    localite: item.structure_LocaliteId.localite,
                    langueID: this.langues.find((x) => x.value === this.contactForm.value.langueId)?.value, // langue du contact
                    paysID: +item.pays,
                    externalApiSourceId: item.structure_LocaliteId.id.toString(),
                  },
                  rue: {
                    codePostal: item.structure_LocaliteId.codePostal,
                    codeRue: item.structure_RueId.codeRue ? item.structure_RueId.codeRue : '',
                    codeLangue: item.structure_RueId.codeLangue ? item.structure_RueId.codeLangue : '',
                    rue: item.structure_RueId.rueNom ? item.structure_RueId.rueNom : '',
                    externalApiSourceId: item.structure_RueId.id ? item.structure_RueId.id.toString() : '',
                  },
                };
                // Si le cp n'est pas d'une autre api, ca ne sert a rien d'ajouter son id externe
                if (!item.structure_LocaliteId?.isFromAnotherAPI) {
                  delete zipAndStreetParams.codePostal.externalApiSourceId;
                }

                this.contactsService.postCodesPostauxRues(zipAndStreetParams).subscribe({
                  next: (res: PostalCodesStreetsDTO) => {
                    temp_array_adress.push({
                      type: item.type && item.type !== null ? item.type : 'PRINCIPALE',
                      description: item.type !== 'PRINCIPALE' ? item.type : '',
                      contactID: this.contactId,
                      adresse: {
                        toRemove: item.toRemove, // Il est forcément false mais on doit l'ajouter
                        structure_LocaliteId: res.codePostal.id ? +res.codePostal.id : null,
                        structure_RueId: res.rue.id ? +res.rue.id : null,
                        structure_RueNumero: item.structure_RueNumero ? item.structure_RueNumero : '',
                        structure_RueBoite: item.structure_RueBoite ? item.structure_RueBoite : '',
                        langueId: this.langues.find((x) => x.value === this.contactForm.value.langueId)?.value,
                        impression_Adresse: item.impression_Adresse
                          ? item.impression_Adresse
                          : item.structure_RueId !== null
                            ? item.structure_RueId.rueNom +
                              (item.structure_RueNumero ? ', ' + item.structure_RueNumero + ', ' : '') +
                              (item.structure_RueBoite ? ' bte ' + item.structure_RueBoite : '')
                            : '',
                        impression_CodePostal: item.impression_CodePostal
                          ? item.impression_CodePostal
                          : res.codePostal.codePostal
                            ? res.codePostal.codePostal
                            : '',
                        impression_Localite: item.impression_Localite
                          ? item.impression_Localite
                          : res.codePostal.localite
                            ? res.codePostal.localite
                            : '',
                        impression_Pays: item.impression_Pays
                          ? item.impression_Pays
                          : this.countriesList.find((x) => x.id === item.pays)?.description,
                        telephone: item.telephone ? item.telephone : '',
                        fax: item.fax ? item.fax : '',
                        gsm: item.gsm ? item.gsm : '',
                        site: item.site ? item.site : '',
                        mail: index === 0 ? this.contactForm.value.mail : item.mail && item.mail !== null ? item.mail : '',
                        id: item.id ? item.id : null,
                      },
                    });
                    cbAsyncEachSeries();
                  },
                });
              } else {
                temp_array_adress.push(this.setNewAddress(item, index));
                cbAsyncEachSeries();
              }
            }
          },
          () => {
            resolve(temp_array_adress);
          }
        );
      } else {
        temp_array_adress.push(this.setNewEmptyAddress());
        resolve(temp_array_adress);
      }
    });
  }

  //to be Put in an utils
  private setNewEmptyAddress(): AddressAsAList {
    return {
      type: 'PRINCIPALE',
      description: 'PRINCIPALE',
      contactID: this.contactId,
      adresse: {
        toRemove: false,
        structure_LocaliteId: null,
        structure_RueId: null,
        structure_RueNumero: '',
        structure_RueBoite: '',
        langueId: this.langues.find((x) => x.value === this.contactForm.value.langueId)?.value,
        impression_Adresse: '',
        impression_CodePostal: '',
        impression_Localite: '',
        impression_Pays: '',
        telephone: '',
        fax: '',
        gsm: '',
        site: '',
        mail: this.contactForm.value.mail ? this.contactForm.value.mail : '',
        id: null,
      },
    };
  }

  //to be Put in an utils
  private setNewAddress(item, index): AddressAsAList {
    return {
      type: item.type && item.type !== null ? item.type : 'PRINCIPALE',
      description: item.type !== 'PRINCIPALE' ? item.type : '',
      contactID: this.contactId,
      adresse: {
        toRemove: item.toRemove, //il FAUT le reprendre sinon on ne supprime jamais plus bas :)
        structure_LocaliteId: item.structure_LocaliteId?.id ? +item.structure_LocaliteId.id : null,
        structure_RueId: item.structure_RueId?.id ? +item.structure_RueId.id : null,
        structure_RueNumero: item.structure_RueNumero ? item.structure_RueNumero : '',
        structure_RueBoite: item.structure_RueBoite ? item.structure_RueBoite : '',
        langueId: this.langues.find((x) => x.value === this.contactForm.value.langueId)?.value,
        impression_Adresse: item.impression_Adresse
          ? item.impression_Adresse
          : item.structure_RueId !== null
            ? item.structure_RueId.rueNom +
              (item.structure_RueNumero ? ', ' + item.structure_RueNumero + ', ' : '') +
              (item.structure_RueBoite ? ' bte ' + item.structure_RueBoite : '')
            : '',
        impression_CodePostal: item.impression_CodePostal
          ? item.impression_CodePostal
          : item.structure_LocaliteId
            ? item.structure_LocaliteId.codePostal
            : '',
        impression_Localite: item.impression_Localite
          ? item.impression_Localite
          : item.structure_LocaliteId
            ? item.structure_LocaliteId.localite
            : '',
        impression_Pays: item.impression_Pays ? item.impression_Pays : this.countriesList.find((x) => x.id === item.pays)?.description,
        telephone: item.telephone ? item.telephone : '',
        fax: item.fax ? item.fax : '',
        gsm: item.gsm ? item.gsm : '',
        site: item.site ? item.site : '',
        mail: index === 0 ? this.contactForm.value.mail : item.mail && item.mail !== null ? item.mail : '',
        id: item.id ? item.id : null,
      },
    };
  }

  submitNewPhysicalContact(): void {
    if (!this.saveOK) return;
    if (this.contact.nom === null) {
      this.toastr.error('Le nom est requis');
      this.spinner.hide();
      return;
    }
    if (this.contact.langueId === null) {
      this.toastr.error('La langue est requise');
      this.spinner.hide();
      return;
    }
    if (this.emailCheckPattern.length > 0) {
      this.toastr.error('Une ou plusieurs adresse(s) email(s) est/sont invalide(s) (exemple@me.com / exemple@me.test.com))');
      this.spinner.hide();
      return;
    }
    if (!this.contactForm.valid) {
      this.toastr.error("Le formulaire n'est pas valide");
      this.spinner.hide();
      return;
    }
    this.contactsService.postContact('iCourrier', this.contact, false).subscribe({
      next: (response) => {
        this.spinner.hide();
        this.toastr.success('Merci', 'Votre contact a bien été créé!');
        this.contact.id = response['id'];
        this.contactCreated = new Contact(response);
        if (this.changeTabViewNotSaveDirectly === true) {
          this.close(this.contact);
        }
        if (this.caller !== 'linked') {
          this.router.navigateByUrl('/private/ic/contacts/details/' + this.contact.id);
        }
      },
      error: (error) => {
        this.spinner.hide();
        console.error('Error', error);
        if (this.contact.listContactsAdresses) {
          let noPrincipalAdresse = false;
          this.contact.listContactsAdresses.map((add) => {
            if (add.type !== 'PRINCIPALE') {
              noPrincipalAdresse = true;
            }
          });
          if (noPrincipalAdresse) {
            this.toastr.error('Si vous renseignez une adresse. Veuillez commencer par la principale !');
          }
        } else {
          this.toastr.error("Une erreur est survenue lors de l'envoi du formulaire");
        }
      },
    });
  }

  private submitNewSocietyContact(): void {
    if (this.contact.nom === null) {
      this.toastr.error('Le nom est requis');
      this.spinner.hide();
      return;
    }
    if (this.contact.langueId === null) {
      this.toastr.error('La langue est requise');
      this.spinner.hide();
      return;
    }
    if (this.emailCheckPattern.length > 0) {
      this.toastr.error('Une ou plusieurs adresse(s) email(s) est/sont invalide(s) (exemple@me.com))');
      this.spinner.hide();
      return;
    }
    this.contactsService.postContact('iCourrier', this.contact).subscribe({
      next: (response) => {
        this.contactCreated = new Contact(response);
        this.spinner.hide();
        this.toastr.success('Merci', 'Votre contact a bien été créé!');
        this.contact.id = response['id'];
        if (this.changeTabViewNotSaveDirectly === true) {
          this.close(this.contact);
        }
      },
      error: (error) => {
        console.error('Error : ', error);
        this.spinner.hide();

        if (this.contact.listContactsAdresses) {
          let noPrincipalAdresse = false;
          this.contact.listContactsAdresses.map((add) => {
            if (add.type !== 'PRINCIPALE') {
              noPrincipalAdresse = true;
            }
          });
          if (noPrincipalAdresse) {
            this.toastr.error('Si vous renseignez une adresse. Veuillez commencer par la principale !');
          }
        } else {
          this.toastr.error("Une erreur est survenue lors de l'envoi du formulaire");
        }
      },
    });
  }

  public leaveInput(type, index): void {
    window.setTimeout(() => {
      if (type === 'cp') {
        const cp = this.contactForm.value.listContactsAdresses.at(index).structure_LocaliteId;

        if (
          typeof cp == 'string' &&
          cp !== '' &&
          (this.contactForm.value.listContactsAdresses.at(index).structure_LocaliteId?.id <= 0 ||
            !this.contactForm.value.listContactsAdresses.at(index).structure_LocaliteId?.id)
        ) {
          this.toastr.warning("Le code postal-localité n'est pas valide. Veuillez en choisir un existant sinon il ne sera pas enregistré");
        }
      } else if (type === 'street') {
        const street = this.contactForm.value.listContactsAdresses.at(index).structure_RueId;
        if (
          typeof street == 'string' &&
          street !== '' &&
          (this.contactForm.value.listContactsAdresses.at(index).structure_RueId?.id <= 0 ||
            !this.contactForm.value.listContactsAdresses.at(index).structure_RueId?.id)
        ) {
          this.toastr.warning("La rue n'est pas valide. Veuillez en choisir une existante sinon elle ne sera pas enregistrée");
        }
      }
    }, 500);
  }

  public selectCountry(data: { originalEvent: PointerEvent; value: number }): void {
    const country = this.countriesList.find((x) => x.id === data.value);
    this.getPostalCodes(country);
  }

  public getPostalCodes(country: CountryDto): Promise<boolean> {
    return new Promise((resolve) => {
      if (country?.id === null) {
        country.id = this.countriesList.find((x) => x.codePays === 'BE').id;
      }

      this.contactsService.getPostalCodesByCountry(country.id).subscribe({
        next: (response: PostalCodeByCountryDTO[]) => {
          this.postalCodesList = response.map((postalCode) => new PostalCodeByCountry(postalCode));
          resolve(true);
        },
        error: (error: HttpErrorResponse) => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des codes postaux');
          console.error(error);
        },
      });
    });
  }

  public selectPostalCode(event, index: number): void {
    if (event.value.id !== -1 && !event.value.isFromAnotherAPI) {
      // si on a choisi un CP normal => de iContact Courrier alors on va récupérer les rues
      this.getStreetsFromiCourrier(event.value);
      this.clearStreet(index);
    } else if (event.value.id === -1) {
      // si on a choisi "Voir plus de code postaux
      const country = this.countriesList.find((x) => x.id === this.getAdressPrincipal.at(index).get('pays').value);
      if (country.codePays !== 'FR') {
        // Alors on va devoir faire un get via iaddress
        this.selectPostalCodeFromiAddress(event.value, country);
      } else {
        // Alors on va devoir faire un get via l api data.gouv française
        this.selectPostalCodeFromFrenchApi(event.value, country);
      }
    } else {
      // Quand on arrive ici c'est qu'on a sélectionné un cp provenant soit de iAddress, soit de l'api française api-adresse.data.gouv.fr
      //pour l'instant on ne fait pas de get avec l'api française car y'a une limite de 50 rues que data.gouv renvoie et donc c'est pas top pour remplir l'array
      this.clearStreet(index);
      if (this.getAdressPrincipal.at(index).get('pays').value !== 'FR') {
        // On arrive ici si on a choisi un CP provenant de iAdresse et donc on va récupérer les rues de ce cp via iAdresse
        // on va devoir envoyer le code langue du contact afin d'afficher les rues dans la bonne langue
        this.getiAddressStreetsByPostalCode(event.value.codePostal);
      }
    }
  }

  private selectPostalCodeFromiAddress(event, country): void {
    this.selectedZIPByFrenchGouvApi = false;
    this.addressesService.fetchLocalities().subscribe({
      next: (res) => {
        this.filteredPostalCodes = [];
        if (res?.length) {
          res.forEach((municipality) => {
            const municipalityName = municipality.nameFr
              ? municipality.nameFr
              : municipality.nameNl
                ? municipality.nameNl
                : municipality.nameDe
                  ? municipality.nameDe
                  : '';
            if (
              municipality.postalcode?.toLowerCase()?.indexOf(event.codePostal) === 0 ||
              municipalityName?.toLowerCase()?.indexOf(event.codePostal) === 0
            ) {
              this.filteredPostalCodes.push({
                id: municipality.id,
                codePostal: municipality.postalcode,
                localite: municipalityName,
                autoCompleteField: municipality.postalcode + ' - ' + municipalityName,
                pays: country,
                isFromAnotherAPI: true,
              });
            }
          });

          if (this.filteredPostalCodes.length === 0) {
            this.stateDropdown.hide();
            this.toastr.info('Aucun résultat pour votre recherche dans iAddress.', 'Information');
          } else {
            this.filteredPostalCodes = this.filteredPostalCodes.sort((a, b) => {
              if (this.numberPattern.test(event.codePostal[0])) {
                return a.codePostal.localeCompare(b.codePostal);
              } else {
                return a.localite.localeCompare(b.localite);
              }
            });
            this.stateDropdown.show();
          }
        } else {
          this.stateDropdown.hide();
          this.toastr.info('Aucun résultat pour votre recherche dans iAddress.', 'Information');
        }
      },
    });
  }

  private selectPostalCodeFromFrenchApi(event, country): void {
    if (typeof event.codePostal === 'number' || !isNaN(event.codePostal)) {
      if (event.codePostal.toString().length !== 5) {
        this.toastr.info('Pour rechercher un code postal composé de chiffres, veuillez entrer le code postal entier (5 chiffres)');
      } else {
        this.selectedZIPByFrenchGouvApi = true;
        this.getFrenchAPIPostCode(event.codePostal, country);
      }
    } else if (typeof event.codePostal === 'string') {
      if (event.codePostal.length < 3) {
        this.toastr.info('Pour rechercher un code postal composé de lettres, veuillez entrer au moins 3 lettres');
      } else {
        this.selectedZIPByFrenchGouvApi = true;
        this.getFrenchAPIPostCode(event.codePostal, country);
      }
    } else {
      this.selectedZIPByFrenchGouvApi = true;
      this.getFrenchAPIPostCode(event.codePostal, country);
    }
  }

  getFrenchAPIPostCode(postCode, country): void {
    // Alors on va devoir faire un get via le site du gouvernement français
    this.contactsService.getFrenchAPIPostCode(postCode).subscribe({
      next: (res) => {
        this.filteredPostalCodes = [];
        if (res?.features.length > 0) {
          res.features.forEach((municipality) => {
            this.filteredPostalCodes.push({
              id: municipality.properties.id,
              codePostal: municipality.properties.postcode,
              localite: municipality.properties.label,
              autoCompleteField: municipality.properties.postcode + ' - ' + municipality.properties.label,
              pays: country,
              isFromAnotherAPI: true,
            });
          });
          if (this.filteredPostalCodes.length === 0) {
            this.stateDropdown.hide();
            this.toastr.info('Aucun résultat pour votre recherche dans iAddress.', 'Information');
          } else {
            this.filteredPostalCodes = this.filteredPostalCodes.sort((a, b) => {
              if (this.numberPattern.test(postCode[0])) {
                return a.codePostal.localeCompare(b.codePostal);
              } else {
                return a.localite.localeCompare(b.localite);
              }
            });
            this.stateDropdown.show();
          }
        } else {
          this.stateDropdown.show();
          this.toastr.warning('Aucun résultats pour votre recherche. Veuillez vérifier le code postal entré');
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error('Une erreur est survenue lors de la récupération des codes postaux (France)');
      },
    });
  }

  getStreetsForChosenZIP(structure_LocaliteId, query: string): Promise<boolean> {
    return new Promise((resolve) => {
      // Si on a un CP de iAdmin
      if (!structure_LocaliteId.isFromAnotherAPI) {
        this.getStreetsFromiCourrier(structure_LocaliteId).then(() => {
          resolve(true);
        });
      } else {
        // Ensuite on détermine si on vient de iAddress ou gouv fr
        // on a pas besoin de resolve car (pour l'instant) cette query n'a besoin de continuer QUE dans le cas de iAdmin
        if (structure_LocaliteId.pays.codePays === 'FR') {
          this.getFrenchAPIStreet(structure_LocaliteId.codePostal, query);
        } else {
          this.getiAddressStreetsByPostalCode(structure_LocaliteId.codePostal).then(() => {
            // Il ne reste plus qu'a filtrer les rues sur celles qui contiennent ce que le user a écrit.
            this.filteredStreets = this.streetsList.filter((street) => street.rueNom.toLowerCase().includes(query.toLowerCase()));
            if (this.filteredStreets.length === 0) {
              this.stateDropdownRue.hide();
              this.toastr.info('Aucun résultat pour votre recherche dans iAddress', 'Information');
            } else {
              this.filteredStreets = this.filteredStreets.sort((a, b) => a.rueNom.localeCompare(b.rueNom));
              this.stateDropdownRue.show();
            }
          });
        }
      }
    });
  }

  selectStreet(event, index): void {
    if (event.value.id === -1) {
      const postalCode = this.getAdressPrincipal.at(index).get('structure_LocaliteId').value;
      const country = this.countriesList.find((x) => x.id === this.getAdressPrincipal.at(index).get('pays').value);
      // Si on est dans "voir plus de rues" alors on doit checker si on est dans le country.codePays Fr ou pas
      // Si c'est "Fr" alors on va faire la recherche via l'API francaise
      if (country.codePays === 'FR') {
        this.getFrenchAPIStreet(postalCode.codePostal, event.value.codeRue);
      } else {
        // Si c'est pas "Fr" alors on va faire la recherche via l'API iAddress
        this.getiAddressStreetsByPostalCode(postalCode.codePostal).then(() => {
          // Il ne reste plus qu'a filtrer les rues sur celles qui contiennent ce que le user a écrit.
          this.filteredStreets = this.streetsList.filter((street) => street.rueNom.toLowerCase().includes(event.value.codeRue.toLowerCase()));
          if (this.filteredStreets.length === 0) {
            this.stateDropdownRue.hide();
            this.toastr.info('Aucun résultat pour votre recherche dans iAddress', 'Information');
          } else {
            this.filteredStreets = this.filteredStreets.sort((a, b) => a.rueNom.localeCompare(b.rueNom));
            this.stateDropdownRue.show();
          }
        });
      }
    }
  }

  private getStreetsFromiCourrier(event): Promise<boolean> {
    return new Promise((resolve) => {
      this.selectedZIPByFrenchGouvApi = false;
      const localiteId = event.id;
      const paysId = event.pays.id;
      this.contactsService.getStreetsByCountry(paysId, localiteId).subscribe({
        next: (response) => {
          this.streetsList = response.map((street) => {
            return new StreetsByCountry(street, 'fromiContact', false);
          });
          this.streetsList = _.sortBy(this.streetsList, 'rueNom');
          resolve(true);
        },
        error: (error) => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des rues');
          console.error(error);
        },
      });
    });
  }

  getFrenchAPIStreet(cityCode: string, streetName: string): void {
    this.contactsService.getFrenchAPIStreet(streetName, +cityCode).subscribe({
      next: (res) => {
        this.filteredStreets = [];
        if (res?.features.length > 0) {
          res.features.forEach((item) => {
            this.filteredStreets.push({
              id: item.properties.id,
              codePostal: item.properties.postcode,
              codeLangue: 'FR',
              codeRue: item.properties.id,
              rueNom: item.properties.name,
              isFromAnotherAPI: true,
            });
          });
          if (this.filteredStreets.length === 0) {
            this.stateDropdownRue.hide();
            this.toastr.info('Aucun résultat pour votre recherche dans l API française.', 'Information');
          } else {
            this.filteredStreets = this.filteredStreets.sort((a, b) => a.rueNom.localeCompare(b.rueNom));
            this.stateDropdownRue.show();
          }
        } else {
          this.stateDropdownRue.hide();
          this.toastr.warning('Aucun résultat pour votre recherche');
        }
      },
    });
  }

  private getiAddressStreetsByPostalCode(postalCode): Promise<boolean> {
    return new Promise((resolve) => {
      this.addressesService.fetchLocalityStreets([postalCode]).subscribe({
        next: (res: StreetByCountryIAddressDTO[]) => {
          const contactLangage = this.langues.find((x) => x.value === this.contactForm.value.langueId)?.codeLangue;
          this.streetsList = res.map((street) => new StreetsByCountry(street, 'fromiAddress', true, contactLangage));
          this.streetsList = _.sortBy(this.streetsList, 'rueNom');
          resolve(true);
        },
        error: (error) => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des rues');
          console.error(error);
        },
      });
    });
  }

  focusAutoComplete(): void {
    if (this.stateDropdown) {
      const random = 'nope-' + (Math.random() + 1).toString(36).substring(7);
      this.stateDropdown.renderer.setAttribute(this.stateDropdown['inputEL'].nativeElement, 'autocomplete', random);
    }
  }

  // AutoComplete for postalCode and street
  public search(event, mode?: string, index?: number): void {
    const query = event ? event.query : null;

    switch (mode) {
      case 'postalCode':
        if (this.postalCodesList.length === 0) {
          if (this.getAdressPrincipal.at(index).value.pays) {
            const countryToSend = this.countriesList.find((country) => country.id === this.getAdressPrincipal.at(index).value.pays);
            this.getPostalCodes(countryToSend).then(() => {
              this.filteredPostalCodes = this.filter(query, this.postalCodesList, mode);
            });
          } else {
            this.toastr.error('Veuillez choisir un pays avant de rechercher une localité');
          }
        } else {
          this.filteredPostalCodes = this.filter(query, this.postalCodesList, mode);
        }
        break;
      case 'street':
        // Si on a un cp de l'api data.gouv alors on doit "juste" faire l'appel des rues vers data.gouv
        // on va ajouter un petit délais afin de ne pas surcharger l'api.
        if (this.selectedZIPByFrenchGouvApi) {
          clearTimeout(this.timeoutForGouvCall);
          this.timeoutForGouvCall = setTimeout(() => {
            const postalCodeToSend = this.getAdressPrincipal.at(index).value.structure_LocaliteId.codePostal;
            this.getFrenchAPIStreet(postalCodeToSend, query);
          }, 1000);
        } else {
          // par contre si on a un cp de iAdmin ou de iAddress, on doit vérifier si on a une liste de rues, sinon on va faire un appel pour les récupérer.
          // on pourrait ne pas avoir de rues si on entre en édition d'un contact et que l'on modifie direct une rue.
          if (this.streetsList.length === 0) {
            if (this.getAdressPrincipal.at(index).value.structure_LocaliteId.codePostal !== null) {
              this.getStreetsForChosenZIP(this.getAdressPrincipal.at(index).value.structure_LocaliteId, query).then(() => {
                this.filteredStreets = this.filter(query, this.streetsList, mode, index);
              });
            } else {
              this.toastr.error('Veuillez choisir un code postal avant de choisir une rue.');
            }
          } else {
            this.filteredStreets = this.filter(query, this.streetsList, mode, index);
          }
        }
        break;
      case 'sector':
        this.filteredSectors = this.filter(query, this.secteursList, mode);
        break;
    }
  }

  public filter(query, list, mode?: string, index?: number) {
    let filtered = [];
    const tempArray = [];
    switch (mode) {
      case 'postalCode':
        list.forEach((postalCode) => {
          if (postalCode?.localite && postalCode.localite.toLowerCase().indexOf(query.toLowerCase()) === 0) {
            filtered.push(postalCode);
          } else if (postalCode?.localite && postalCode.codePostal.indexOf(query) === 0) {
            filtered.push(postalCode);
          }
        });

        filtered = filtered.sort((a, b) => {
          if (this.numberPattern.test(query[0])) {
            // Si on commence par un nombre => trie par codes postaux
            return a.codePostal.localeCompare(b.codePostal);
          } else {
            // Si on commence par une lettre => trie par localités
            return a.localite.localeCompare(b.localite);
          }
        });

        filtered.push({
          autoCompleteField: 'Voir plus de codes postaux',
          codePostal: query,
          id: -1,
          localite: 'Voir plus de codes postaux',
          isFromAnotherAPI: true,
        });
        break;
      case 'street': {
        list.forEach((street) => {
          if (street.rueNom.toLowerCase().includes(query.toLowerCase())) {
            tempArray.push(street);
          }
        });
        const contactLangage = this.langues.find((x) => x.value === this.contactForm.value.langueId)?.codeLangue;

        filtered = tempArray.filter((x) => (['FR', 'NL', 'DE'].includes(contactLangage) ? x.codeLangue === contactLangage : x.codeLangue === 'FR'));

        filtered = filtered.sort((a, b) => a.rueNom.localeCompare(b.rueNom));

        if (this.getAdressPrincipal.at(index).value.structure_LocaliteId.isFromAnotherAPI === false) {
          filtered.push({
            id: -1,
            codePostal: null,
            codeRue: query,
            codeLangue: null,
            rueNom: 'Voir plus de rues',
            isFromAnotherAPI: true,
          });
        }

        break;
      }

      case 'sector':
        list.map((sector) => {
          if (sector.label.toLowerCase().includes(query.toLowerCase())) {
            filtered.push(sector);
          }
        });
        break;
    }
    return filtered;
  }

  public showMore(): void {
    this.fullMode = !this.fullMode;
  }

  initForm(): void {
    this.contactForm = this.formBuilder.group({
      prenom: new UntypedFormControl(null, [Validators.maxLength(200)]),
      nom: new UntypedFormControl(null, [Validators.maxLength(200), Validators.required]),
      titre: new UntypedFormControl(null),
      fonction: new UntypedFormControl(null, [Validators.maxLength(200)]),
      typeContactId: new UntypedFormControl(null),
      nomInterne: new UntypedFormControl(null),
      typeSociete: new UntypedFormControl(this.companyMode, Validators.required),
      gerantSociete: new UntypedFormControl(null),
      membrePersonnel: new UntypedFormControl(null),
      nePlusUtiliser: new UntypedFormControl(null),
      secteurActivite: new UntypedFormControl(null),
      tvaPrefix: new UntypedFormControl('BE'),
      tva: new UntypedFormControl(null),
      societeFormeJuridiqueId: new UntypedFormControl(null),
      bce: new UntypedFormControl(null),
      listContactsAdresses: new UntypedFormArray([]),
      listSocieteLies: new UntypedFormControl(null),
      siteWeb: new UntypedFormControl(null, [ValidatorsComponent.URL()]),
      langueId: new UntypedFormControl(1, Validators.required),
      numeroCarteNISS: new UntypedFormControl(null),
      dateNaissance: new UntypedFormControl(null),
      naissanceLieu: new UntypedFormControl(null),
      etatCivil: new UntypedFormControl(null),
      sexe: new UntypedFormControl(null),
      nationalite: new UntypedFormControl(),
      commentaires: new UntypedFormControl(null),
      signature1: new UntypedFormControl(null),
      signature2: new UntypedFormControl(null),
      signatureCertifactNom: new UntypedFormControl(null),
      mail: new UntypedFormControl(null),
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.contactForm.controls;
  }

  get getAdressPrincipal(): UntypedFormArray {
    return this.contactForm.get('listContactsAdresses') as UntypedFormArray;
  }

  add(): void {
    this.getAdressPrincipal.push(
      this.formBuilder.group({
        type: new UntypedFormControl(this.getAdressPrincipal.length ? 'SECONDAIRE' : 'PRINCIPALE', Validators.required),
        structure_RueId: new UntypedFormControl(null),
        structure_RueNumero: new UntypedFormControl(null),
        structure_RueBoite: new UntypedFormControl(null),
        structure_LocaliteId: new UntypedFormControl(null),
        impression_Pays: new UntypedFormControl(null),
        impression_CodePostal: new UntypedFormControl(null),
        impression_Localite: new UntypedFormControl(null),
        impression_Adresse: new UntypedFormControl(null),
        pays: new UntypedFormControl(
          this.clientType !== 'JVS' ? this.countriesList.find((x) => x.codePays === 'BE').id : this.countriesList.find((x) => x.codePays === 'FR').id
        ),
        gsm: new UntypedFormControl(null),
        mail: new UntypedFormControl(null, [Validators.email]),
        telephone: new UntypedFormControl(null),
        fax: new UntypedFormControl(null),
        site: new UntypedFormControl(null),
        toRemove: new UntypedFormControl(false),
      })
    );
    this.listOfDisplayedImpressionAdresses.push(false);
  }

  remove(index): void {
    this.confirmationService.confirm({
      message: 'Voulez-vous vraiment supprimer cette adresse ?',
      key: 'Address',
      accept: () => {
        const toFind = this.getAdressPrincipal.at(index);

        toFind.value.toRemove = true;
        this.getAdressPrincipal.at(index).patchValue({
          toRemove: true,
        });

        this.listOfDisplayedImpressionAdresses[index] = false;

        this.toastr.success('Adresse supprimée temporairement, vous devez cliquer sur enregistrer pour valider vos changements!');
        if (this.getAdressPrincipal.length === 0) {
          const data = {
            type: 'PRINCIPALE',
            structure_RueId: '',
            structure_RueNumero: '',
            structure_RueBoite: '',
            structure_LocaliteId: '',
            pays: '',
            gsm: '',
            mail: '',
            telephone: '',
            fax: '',
            site: '',
          };
          this.contactForm.value.listContactsAdresses = data;
        }
      },
    });
  }

  public switchToCompany(): void {
    this.companyMode = !this.companyMode;
  }

  onTvaCodeChg(codeTva): void {
    this.codePays = codeTva;
    this.tvaFrMode = false;
    const tvaCountry = this.countriesList.find((p) => p.codePays === codeTva);
    this.paysContactID = tvaCountry.id;
    switch (codeTva) {
      case 'BE':
        this.contact.pasDeTVABelge = false;
        this.tvaMask = `BE-9999999999`;
        this.tvaPlaceholder = 'BE-9999999999';
        this.bcePlaceholder = '9999999999';
        this.bceMask = '9999999999';
        this.bceTooltip = '10 chiffres.';
        break;
      case 'NL':
        this.contact.pasDeTVABelge = true;
        this.tvaMask = `NL-999999999B99`;
        this.tvaPlaceholder = 'NL-999999999B99';
        this.bcePlaceholder = '';
        this.bceMask = '';
        this.bceTooltip = '';
        break;
      case 'LU':
        this.contact.pasDeTVABelge = true;
        this.tvaMask = `LU-99999999`;
        this.tvaPlaceholder = 'LU-99999999';
        this.bcePlaceholder = '';
        this.bceMask = '';
        this.bceTooltip = '';
        break;
      case 'FR':
        this.contact.pasDeTVABelge = true;
        this.tvaFrMode = true;
        this.contactForm.patchValue({ tva: null });
        this.bcePlaceholder = '';
        this.bceMask = '';
        this.bceTooltip = '';
        break;
      case 'DE':
        this.contact.pasDeTVABelge = true;
        this.tvaMask = `DE-999999999`;
        this.tvaPlaceholder = 'DE-999999999';
        this.bcePlaceholder = '';
        this.bceMask = '';
        this.bceTooltip = '';

        break;
    }
  }

  public close(result?: string): void {
    if (this.contactForm.dirty && !this.isFormSubmit) {
      this.confirmationService.confirm({
        message: 'Si vous quittez maintenant vous allez perdre vos changements, voulez-vous continuer?',
        icon: 'bi bi-exclamation-triangle',
        accept: () => {
          this.ref.close(result);
        },
        key: 'Close',
      });
    } else {
      this.ref.close(result);
    }
  }

  onCountryChange(country: string): void {
    this.prefixNumber = '';
    this.countriesJSON['default'].filter((item) => {
      if (country === item.code) {
        this.prefixNumber = item.value;
      }
    });
  }

  convertImpression(index: number): void {
    const address: StreetsByCountry = this.getAdressPrincipal.at(index).get('structure_RueId').value;
    const cp = this.getAdressPrincipal.at(index).get('structure_LocaliteId').value;
    const pays = this.getAdressPrincipal.at(index).get('pays').value;
    const number: string = this.getAdressPrincipal.at(index).get('structure_RueNumero').value;
    const boite: string = this.getAdressPrincipal.at(index).get('structure_RueBoite').value;

    const gen_address = this.setAddressConfig(address, boite, number);

    this.getAdressPrincipal.at(index).patchValue({
      impression_Adresse: gen_address,
      impression_CodePostal: cp ? cp.codePostal : '',
      impression_Localite: cp?.city ? cp.city : cp?.localite ? cp.localite : '',
      impression_Pays: pays ? this.countriesList.find((x) => x.id === pays).description : '',
    });
  }

  openNewPostalCodeModal(i: number, type: 'structure' | 'impression'): void {
    this.actualIndexOfAddressToBeModified = i;
    this.typeOfAddressToBeModified = type;
    this.countriesService.fetchCountries().subscribe({
      next: (res: CountryDto[]) => {
        this.countries = [];
        if (res?.length > 0) {
          res.map((item) => {
            this.countries.push({ label: item.description, value: item.id });
          });
        }
        this.showCreateCP = true;
      },
      error: (err: HttpErrorResponse) => console.error(err),
    });
  }

  openNewStreetModal(i: number, type: 'structure' | 'impression'): void {
    this.actualIndexOfStreetToBeModified = i;
    this.typeOfStreetToBeModified = type;
    this.showCreateStreet = true;
  }

  openNewTypeContact(): void {
    this.spinner.show();
    forkJoin({
      contactTypes: this.contactsGlobalService.fetchContactTypes().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue lors de la recherche des types de contact');
          this.spinner.hide();
          return of(null);
        })
      ),
      contactsGroups: this.groupsService.fetchGlobalGroups().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue lors de la recherche des groupes de contact');
          this.spinner.hide();
          return of(null);
        })
      ),
      lowInfosIC: this.contactsService.getLowInformationsContactsiCourrier({ includeContactParent: true }).pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue lors de la recherche des contacts de iCourrier');
          this.spinner.hide();
          return of(null);
        })
      ),
    }).subscribe((value) => {
      this.formatContactsTypes(value.contactTypes);
      this.formatContactsGroups(value.contactsGroups);
      this.formatLowInformationsContactsiCourrier(value.lowInfosIC);
      this.spinner.hide();
      this.showCreateContactType = true;
    });
  }

  private formatContactsTypes(contactTypes: ContactTypeDto[]): void {
    this.typesLV = [];
    if (contactTypes?.length) {
      contactTypes.forEach((item) => {
        this.typesLV.push({ label: item.typeContact, value: item.id });
      });
    }
  }

  private formatContactsGroups(contactGroups: GroupsGlobalDto[]): void {
    this.groups = [];
    if (contactGroups.length) {
      contactGroups.forEach((item) => {
        this.groups.push({ label: item.description, value: item.id });
      });
    }
  }

  private formatLowInformationsContactsiCourrier(lowInfosContacts: LowInformationsDTO[]): void {
    this.contactsInit = [];
    lowInfosContacts.forEach((contact) => {
      const newContact = new Contact(contact);
      if (newContact) {
        newContact.name = (newContact.prenom ? newContact.prenom : '') + ' ' + (newContact.nom ? newContact.nom : '');
        newContact.contactId = newContact.contactID ? newContact.contactID : newContact.contactId;
        this.contactsInit.push(newContact);
      }
    });
    this.contactsLinked = _.sortBy(this.contactsInit, 'label');
  }

  filterContact(event): void {
    if (event?.value !== null) {
      this.contacts = this.contactsInit.filter((x) => x.typeContactID === event.value);
    } else {
      this.contacts = this.contactsInit;
    }
  }

  submitNewCP(): void {
    if (this.formCP.valid) {
      this.contactsService.postPostalCode(this.formCP.value).subscribe({
        next: (res: ManagementPostalCodesDTO) => {
          if (this.typeOfAddressToBeModified === 'structure') {
            // on va déjà vérifier s'il y a un pays dans le formulaire et que celui-ci soit égal au pays de l'adresse créée.
            const country = this.countriesList.find((x) => x.id === this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).value.pays);
            if (country?.id && this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).value.pays === this.formCP.value.paysID) {
              this.getPostalCodes(country).then(() => {
                let locToPatch;
                if (this.postalCodesList.find((x) => x.id === res.id)?.id) {
                  //si on a bien une localité
                  locToPatch = this.postalCodesList.find((x) => x.id === res.id);
                  locToPatch.autoCompleteField =
                    (locToPatch.codePostal ? locToPatch.codePostal : '') + ': ' + (locToPatch.localite ? locToPatch.localite : '');
                }
                // Si on a une localité a patcher, il faut vider la rue!
                this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).patchValue({
                  structure_LocaliteId: this.postalCodesList.find((x) => x.id === res.id)?.id
                    ? locToPatch
                    : this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).value.structure_LocaliteId,
                  structure_RueId: locToPatch ? null : this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).value.structure_RueId,
                });

                //Une fois le patch effectué, on va aller essayer de récupérer toutes les rues
                //déjà on va le faire ssi il existe un pays && une loc dans le formulaire
                if (this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).value.structure_LocaliteId?.id) {
                  const data = {
                    id: this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).value.structure_LocaliteId.id,
                    pays: country,
                  };
                  this.getStreetsFromiCourrier(data);
                  this.toastr.success('Le code postal a bien été enregistré');
                  this.formCP.reset();
                  this.showCreateCP = false;
                } else {
                  this.toastr.success('Le code postal a bien été enregistré');
                  this.formCP.reset();
                  this.showCreateCP = false;
                }
              });
            }
          } else {
            this.getAdressPrincipal.at(this.actualIndexOfAddressToBeModified).patchValue({
              impression_CodePostal: res.codePostal,
              impression_Localite: res.localite,
              impression_Adresse: '',
            });
            this.toastr.success('Le code postal a bien été enregistré');
            this.formCP.reset();
            this.showCreateCP = false;
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la création du code postal');
        },
      });
    } else {
      this.toastr.warning("Vous n'avez pas rempli tous les champs obligatoires");
    }
  }
  submitNewStreet(): void {
    if (this.formStreet.valid) {
      this.contactsService.postStreet(this.formStreet.value).subscribe({
        next: (res: ManagementStreetsDTO) => {
          if (this.typeOfStreetToBeModified === 'structure') {
            // On va déjà vérifier s'il y a un cp et si celui ci correspond au cp de la rue créée
            const zip = this.getAdressPrincipal.at(this.actualIndexOfStreetToBeModified).value.structure_LocaliteId?.codePostal;
            const country = this.countriesList.find((x) => x.id === this.getAdressPrincipal.at(this.actualIndexOfStreetToBeModified).value.pays);
            if (zip && zip === this.formStreet.value.codePostal) {
              const data = {
                id: this.getAdressPrincipal.at(this.actualIndexOfStreetToBeModified).value.structure_LocaliteId.id,
                pays: country,
              };
              this.getStreetsFromiCourrier(data).then(() => {
                this.getAdressPrincipal.at(this.actualIndexOfStreetToBeModified).patchValue({
                  structure_RueId: this.streetsList.find((x) => x.id === res.id)?.id
                    ? this.streetsList.find((x) => x.id === res.id)
                    : this.getAdressPrincipal.at(this.actualIndexOfStreetToBeModified).value.structure_RueId,
                });
                this.toastr.success('La rue a bien été enregistrée');
                this.formStreet.reset();
                this.showCreateStreet = false;
              });
            }
          } else {
            this.getAdressPrincipal.at(this.actualIndexOfStreetToBeModified).patchValue({
              impression_Adresse: res.rue,
            });
            this.toastr.success('La rue a bien été enregistrée');
            this.formStreet.reset();
            this.showCreateStreet = false;
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la création de la rue');
        },
      });
    } else {
      this.toastr.warning("Vous n'avez pas rempli tous les champs obligatoires");
    }
  }
  submitNewContactType(): void {
    if (this.formContactType.value.categorie === null) {
      this.formContactType.value.categorie = false;
    }
    if (this.formContactType.value.nePasInclureArbreDestinataires === null) {
      this.formContactType.value.nePasInclureArbreDestinataires = false;
    }
    if (this.formContactType.value.nePasRemplirLaListe === null) {
      this.formContactType.value.nePasRemplirLaListe = false;
    }
    if (this.formContactType.value.sanctionTypeVictime === null) {
      this.formContactType.value.sanctionTypeVictime = false;
    }
    if (this.formContactType.value.verrouille === null) {
      this.formContactType.value.verrouille = false;
    }
    if (this.formContactType.valid) {
      this.contactsService.postManagementContactType(this.formContactType.value).subscribe({
        next: (res: ContactTypeDto) => {
          this.toastr.success('Le type a bien été enregistré');
          this.showCreateContactType = false;
          //on va récupérer tous les types de contacts puis patcher

          this.contactsGlobalService.fetchMappedContactTypesToPrimeNGDropdowns().subscribe({
            next: (response) => {
              this.typeContacts = response;
              this.typeContacts.map((item) => {
                item.label = item.label.charAt(0).toUpperCase() + String(item.label).slice(1).toLowerCase();
              });
              this.contactForm.patchValue({ typeContactId: res.id });
            },
            error: (err) => {
              console.error(err);
            },
          });
        },
      });
    } else {
      this.toastr.warning("Vous n'avez pas rempli tous les champs obligatoires");
    }
  }
  changeTabView(event): void {
    this.changeTabViewNotSaveDirectly = false;
    this.activeIndex = 0;
    if (event?.index !== 0) {
      if (!this.contactCreated) {
        this.confirmationService.confirm({
          message:
            "Pour passer sur cet onglet, vous devez enregistrer un contact d'abord, voulez-vous continuer et enregistrer vos changements actuels?",
          icon: 'bi bi-exclamation-triangle',

          accept: () => {
            if (this.contactForm.value.langueId !== null && this.contactForm.value.nom !== null) {
              this.onSubmit();
              this.activeIndex = 1;
              this.tabs[0].active = false;
              this.tabs[1].active = true;
            } else {
              this.toastr.warning("Le formulaire n'est pas valide");
              this.tabs[0].active = true;
              this.tabs[1].active = false;
            }
          },
          reject: () => {
            this.activeIndex = 0;
            this.tabs[0].active = true;
            this.tabs[1].active = false;
          },
          key: 'Close',
        });
      }
    }
  }

  public clearStreet(index: number): void {
    this.getAdressPrincipal.at(index).patchValue({ structure_RueId: null });
  }

  public clearZIPAndStreet(index: number): void {
    this.getAdressPrincipal.at(index).patchValue({ structure_LocaliteId: null, structure_RueId: null });
  }

  public onSelectSector(event): void {
    this.contactForm.value.secteurActivite = event.value;
  }
}
